// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Arbeitsschutz and Ausbildung pages. Every selector is scoped to the page root; dialogs get it
   as rootClassName because they render outside the page. */

:is(.safety-page, .apprenticeship-page) .sf-full {
  width: 100%;
}

:is(.safety-page, .apprenticeship-page) .sf-small {
  font-size: 13px;
  color: var(--ds-text-muted);
}

:is(.safety-page, .apprenticeship-page) .sf-wrap {
  overflow-wrap: anywhere;
}

:is(.safety-page, .apprenticeship-page) .sf-center {
  display: flex;
  justify-content: center;
  padding: var(--ds-space-6, 32px);
}

:is(.safety-page, .apprenticeship-page) .sf-empty-text {
  max-width: 520px;
  margin-inline: auto;
}

:is(.safety-page, .apprenticeship-page) .sf-filter {
  min-width: 180px;
}

:is(.safety-page, .apprenticeship-page) .sf-label {
  display: block;
  margin-bottom: 4px;
  font-size: 13px;
  color: var(--ds-text-muted);
}

:is(.safety-page, .apprenticeship-page) .sf-footer-note {
  margin-top: var(--ds-space-4, 16px);
}

:is(.safety-page, .apprenticeship-page) .sf-content-preview {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

/* ---- Editor header ---- */
:is(.safety-page, .apprenticeship-page) .sf-header {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
  flex-wrap: wrap;
}

:is(.safety-page, .apprenticeship-page) .sf-header-title {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
  flex: 1 1 0;
  min-width: 0;
}

:is(.safety-page, .apprenticeship-page) .sf-header-title h4 {
  margin: 0;
  overflow-wrap: anywhere;
}

/* ---- Gefährdungsbeurteilung ---- */
.safety-page .sf-hazard {
  border: 1px solid var(--ds-border);
  border-radius: var(--ds-radius-md, 10px);
  padding: var(--ds-space-3);
  margin-bottom: var(--ds-space-3);
  background: var(--ds-surface);
}

.safety-page .sf-hazard-head {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
  margin-bottom: var(--ds-space-2);
}

.safety-page .sf-measure {
  margin-bottom: var(--ds-space-2);
  padding-block-start: var(--ds-space-2);
  border-top: 1px dashed var(--ds-border);
}

.safety-page .sf-measure-end {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
}

.safety-page .sf-risk {
  margin-top: 4px;
  white-space: nowrap;
}

/* ---- Berichtsheft ---- */
.apprenticeship-page .ap-day {
  border: 1px solid var(--ds-border);
  border-radius: var(--ds-radius-md, 10px);
  padding: var(--ds-space-3);
  margin-bottom: var(--ds-space-3);
  background: var(--ds-surface);
}

.apprenticeship-page .ap-day-head {
  display: flex;
  align-items: center;
  gap: var(--ds-space-2);
  flex-wrap: wrap;
  margin-bottom: var(--ds-space-2);
}

.apprenticeship-page .ap-day-title {
  flex: 1 1 auto;
  min-width: 0;
  font-weight: 600;
}

.apprenticeship-page .ap-activity {
  display: flex;
  gap: var(--ds-space-2);
  align-items: flex-start;
  margin-bottom: var(--ds-space-2);
}

.apprenticeship-page .ap-activity-text {
  flex: 1 1 auto;
  min-width: 0;
}

.apprenticeship-page .ap-hours {
  flex: 0 0 88px;
}

.apprenticeship-page .ap-total {
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.apprenticeship-page .ap-comment {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/safety/safety.css"],"names":[],"mappings":"AAAA;2DAC2D;;AAE3D;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,uBAAuB;AACzB;;AAEA,qCAAqC;AACrC;EACE,kCAAkC;EAClC,wCAAwC;EACxC,0BAA0B;EAC1B,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,kCAAkC;EAClC,wCAAwC;EACxC,0BAA0B;EAC1B,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB","sourcesContent":["/* Arbeitsschutz and Ausbildung pages. Every selector is scoped to the page root; dialogs get it\n   as rootClassName because they render outside the page. */\n\n:is(.safety-page, .apprenticeship-page) .sf-full {\n  width: 100%;\n}\n\n:is(.safety-page, .apprenticeship-page) .sf-small {\n  font-size: 13px;\n  color: var(--ds-text-muted);\n}\n\n:is(.safety-page, .apprenticeship-page) .sf-wrap {\n  overflow-wrap: anywhere;\n}\n\n:is(.safety-page, .apprenticeship-page) .sf-center {\n  display: flex;\n  justify-content: center;\n  padding: var(--ds-space-6, 32px);\n}\n\n:is(.safety-page, .apprenticeship-page) .sf-empty-text {\n  max-width: 520px;\n  margin-inline: auto;\n}\n\n:is(.safety-page, .apprenticeship-page) .sf-filter {\n  min-width: 180px;\n}\n\n:is(.safety-page, .apprenticeship-page) .sf-label {\n  display: block;\n  margin-bottom: 4px;\n  font-size: 13px;\n  color: var(--ds-text-muted);\n}\n\n:is(.safety-page, .apprenticeship-page) .sf-footer-note {\n  margin-top: var(--ds-space-4, 16px);\n}\n\n:is(.safety-page, .apprenticeship-page) .sf-content-preview {\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n/* ---- Editor header ---- */\n:is(.safety-page, .apprenticeship-page) .sf-header {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  flex-wrap: wrap;\n}\n\n:is(.safety-page, .apprenticeship-page) .sf-header-title {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n:is(.safety-page, .apprenticeship-page) .sf-header-title h4 {\n  margin: 0;\n  overflow-wrap: anywhere;\n}\n\n/* ---- Gefährdungsbeurteilung ---- */\n.safety-page .sf-hazard {\n  border: 1px solid var(--ds-border);\n  border-radius: var(--ds-radius-md, 10px);\n  padding: var(--ds-space-3);\n  margin-bottom: var(--ds-space-3);\n  background: var(--ds-surface);\n}\n\n.safety-page .sf-hazard-head {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  margin-bottom: var(--ds-space-2);\n}\n\n.safety-page .sf-measure {\n  margin-bottom: var(--ds-space-2);\n  padding-block-start: var(--ds-space-2);\n  border-top: 1px dashed var(--ds-border);\n}\n\n.safety-page .sf-measure-end {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 4px;\n}\n\n.safety-page .sf-risk {\n  margin-top: 4px;\n  white-space: nowrap;\n}\n\n/* ---- Berichtsheft ---- */\n.apprenticeship-page .ap-day {\n  border: 1px solid var(--ds-border);\n  border-radius: var(--ds-radius-md, 10px);\n  padding: var(--ds-space-3);\n  margin-bottom: var(--ds-space-3);\n  background: var(--ds-surface);\n}\n\n.apprenticeship-page .ap-day-head {\n  display: flex;\n  align-items: center;\n  gap: var(--ds-space-2);\n  flex-wrap: wrap;\n  margin-bottom: var(--ds-space-2);\n}\n\n.apprenticeship-page .ap-day-title {\n  flex: 1 1 auto;\n  min-width: 0;\n  font-weight: 600;\n}\n\n.apprenticeship-page .ap-activity {\n  display: flex;\n  gap: var(--ds-space-2);\n  align-items: flex-start;\n  margin-bottom: var(--ds-space-2);\n}\n\n.apprenticeship-page .ap-activity-text {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.apprenticeship-page .ap-hours {\n  flex: 0 0 88px;\n}\n\n.apprenticeship-page .ap-total {\n  font-variant-numeric: tabular-nums;\n  white-space: nowrap;\n}\n\n.apprenticeship-page .ap-comment {\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
